import {DataObjectId} from 'yougile-model'
import {SyncEvents} from '@client/sync-events'
import {globals} from '@extensions/globals-base'

export const refreshAfterMovementChanges = (boardId: DataObjectId): void => {
  const companyId = globals.getCompanyId()

  setTimeout(() => {
    SyncEvents.trigger(companyId, [boardId], false)
  }, 1000)
}
